import React, { useEffect, useRef } from 'react';
import { ProjectData } from './projectData';

interface ProjectHeaderProps {
  project: ProjectData;
  showAppStoreLink?: boolean; // MobileProjectのみtrue
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({ project, showAppStoreLink = false }) => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    // 改善された動的フォントサイズ調整ロジック
    const updateFontSize = () => {
      if (titleRef.current) {
        const containerWidth = titleRef.current.parentElement?.offsetWidth || window.innerWidth - 240; // 左右パディング考慮
        const titleText = titleRef.current.textContent || '';

        // デフォルトフォントサイズを大きめに設定
        let baseFontSize = 72; // 固定の基本サイズ

        // 文字数が多い場合のみ調整
        if (titleText.length > 20) {
          baseFontSize = 60;
        } else if (titleText.length > 15) {
          baseFontSize = 66;
        }

        // 実際に要素に適用してチェック
        titleRef.current.style.fontSize = `${baseFontSize}px`;

        // 要素が親要素を超える場合のみ調整
        const titleWidth = titleRef.current.scrollWidth;
        const maxWidth = containerWidth - 40; // 余白を考慮

        if (titleWidth > maxWidth) {
          const ratio = maxWidth / titleWidth;
          baseFontSize = baseFontSize * ratio * 0.95; // 少し余裕を持たせる
          titleRef.current.style.fontSize = `${Math.max(32, baseFontSize)}px`; // 最小32px
        }

        console.log(`📏 Font size adjusted: ${baseFontSize}px for "${titleText}" (${titleText.length} chars)`);
      }
    };

    updateFontSize();
    window.addEventListener('resize', updateFontSize);
    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  // カテゴリを配列として扱う
  const categories = Array.isArray(project.category) ? project.category : [project.category];

  // movieとdesignカテゴリはリンクを表示しない
  const shouldShowLinks = !categories.includes('movie') && !categories.includes('design');

  return (
    <div className="project-header">
      <h1 ref={titleRef} className="project-title">{project.title}</h1>
      <div className="project-meta">
        <div className="project-meta-row">
          <span className="project-detail-category">
            {categories.join(', ')}
          </span>
        </div>
        {shouldShowLinks && (
          <div className="project-links-row">
            {/* websiteリンク */}
            {project.url ? (
              <a href={project.url} target="_blank" rel="noopener noreferrer" className="project-link">
                website <span className="project-title-arrow">↗</span>
              </a>
            ) : !showAppStoreLink ? (
              // websiteがなく、app storeも表示しない場合、statusを参照
              project.status === 'done' ? (
                <span className="project-link-disabled">no site</span>
              ) : (
                <span className="project-link-disabled">coming soon</span>
              )
            ) : null}

            {/* app storeがある場合の区切り */}
            {showAppStoreLink && project.url && (
              <span className="project-link-separator"> / </span>
            )}

            {/* app storeリンク */}
            {showAppStoreLink && (
              project.appStoreUrl ? (
                <a href={project.appStoreUrl} target="_blank" rel="noopener noreferrer" className="project-link">
                  app store <span className="project-title-arrow">↗</span>
                </a>
              ) : !project.url ? (
                // 両方ともない場合のみcoming soon
                <span className="project-link-disabled">coming soon</span>
              ) : null
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectHeader;
